// @flow

import { price } from '../classes/Helpers';
import CartTotal from './CartTotal';
import Notifications from '../constants/Notifications';

export default class CartSummary extends CartTotal {
  subtotal: HTMLElement;
  shippingCosts: HTMLElement;
  discountWrapper: HTMLElement;
  totalDiscount: HTMLElement;
  totalReward: HTMLElement;
  couponDiscount: HTMLElement;
  couponCode: HTMLElement;
  couponReward: HTMLElement;
  subscriptionDiscount: HTMLElement;
  subscriptionReward: HTMLElement;
  paymentFeeContainer: HTMLElement;
  paymentFee: HTMLElement;

  /**
   * Initialize the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.setProperties([
      'subtotal',
      'shippingCosts',
      'discountWrapper',
      'totalDiscount',
      'totalReward',
      'couponDiscount',
      'subscriptionDiscount',
      'couponCode',
      'couponReward',
      'subscriptionReward',
      'paymentFee',
      'paymentFeeContainer'
    ]);

    this.addListener(Notifications.UPDATE_PAYMENT_FEE, this.updatePaymentFee.bind(this));
  }

  /**
   * Update the prices
   */
  update(data: Object): void {
    if (Array.isArray(data)) {
      data = data[0];
    }
    const couponCode: string = data.code ?? null;

    this.subtotal.innerText = price(data.summary.subtotal);

    this.updateCoupon(couponCode, +data.summary?.discount);
    this.updateTotalDiscount(+data.summary?.discount, +data.summary?.subscriptionDiscount);
    this.updateShippingCosts(data.summary.shipping);
    this.updateSubscriptionDiscount(+data.summary?.subscriptionDiscount);

    super.update(data);
  }

  /**
   * Update the shipping costs
   */
  updateShippingCosts(costs: number): void {
    if (costs > 0) {
      this.shippingCosts.innerText = price(costs);
      return;
    }

    this.shippingCosts.innerText = this.shippingCosts.dataset.translation;
  }

  /**
   * Update the total discount line
   */
  updateTotalDiscount(couponReward: number, subscriptionReward: number): void {
    if (!couponReward && !subscriptionReward) {
      this.discountWrapper.classList.add('hidden');
      return;
    }

    this.totalReward.innerText = price(couponReward + subscriptionReward);

    this.totalDiscount.classList.remove('hidden');
    this.discountWrapper.classList.remove('hidden');
  }

  updateSubscriptionDiscount(subscriptionReward: number): void {
    if (!subscriptionReward) return;
    this.subscriptionReward.innerText = price(subscriptionReward);
    this.subscriptionDiscount.classList.remove('hidden');
  }

  updatePaymentFee({ paymentFee }: Object) {
    if (paymentFee) {
      this.paymentFee.innerHTML = price(paymentFee);
      this.paymentFeeContainer.classList.remove('hidden');
      super.update({ summary: { total: this.totalPrice + paymentFee } });
    } else {
      this.paymentFeeContainer.classList.add('hidden');
      super.update({ summary: { total: this.totalPrice } });
    }
  }

  /**
   * Update the coupon line
   */
  updateCoupon(code?: string, reward?: number): void {
    if (!reward) {
      this.couponDiscount.classList.add('hidden');
      return;
    }

    this.couponCode.innerHTML = code || window.store.getTranslation('Coupon code');
    this.couponReward.innerText = price(reward);
    this.couponDiscount.classList.remove('hidden');
  }
}
